var React = require('react');

function IconTwitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"twitter"),React.createElement("path",{"d":"M69.89,39.8c0,.44,0,.88,0,1.33,0,13.56-10.33,29.19-29.2,29.19A29.11,29.11,0,0,1,25,65.72a21.83,21.83,0,0,0,2.45.13,20.61,20.61,0,0,0,12.74-4.38,10.29,10.29,0,0,1-9.59-7.13,10.27,10.27,0,0,0,1.93.18,10.6,10.6,0,0,0,2.71-.35A10.29,10.29,0,0,1,27,44.1.62.62,0,0,1,27,44a10.12,10.12,0,0,0,4.64,1.28,10.26,10.26,0,0,1-3.17-13.69A29.1,29.1,0,0,0,49.62,42.28a10.62,10.62,0,0,1-.26-2.34,10.26,10.26,0,0,1,17.74-7,20.42,20.42,0,0,0,6.52-2.49,10.29,10.29,0,0,1-4.51,5.68A20.48,20.48,0,0,0,75,34.49,20.48,20.48,0,0,1,69.89,39.8Z","key":1})]);
}

IconTwitter.displayName = "IconTwitter";

IconTwitter.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = IconTwitter;

IconTwitter.default = IconTwitter;
